/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateBatchDataEntryLinkRequestUpdatesFromJSON, UpdateBatchDataEntryLinkRequestUpdatesToJSON, } from './';
export function UpdateBatchDataEntryLinkRequestFromJSON(json) {
    return UpdateBatchDataEntryLinkRequestFromJSONTyped(json, false);
}
export function UpdateBatchDataEntryLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ids: json['ids'],
        updates: UpdateBatchDataEntryLinkRequestUpdatesFromJSON(json['updates']),
    };
}
export function UpdateBatchDataEntryLinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ids: value.ids,
        updates: UpdateBatchDataEntryLinkRequestUpdatesToJSON(value.updates),
    };
}
